import {param, typedQuery} from "../../typing";
import externalApi from "../../../api/external";
import {AccountMin, Region} from "../../../Types";

export const regions = typedQuery(["external", "portal", "regions", param<AccountMin>("account")], async account => {
  return await externalApi.portalDiscovery.listRegions(account);
});

export const portals = typedQuery(
  ["external", "portal", "third_parties", param<AccountMin>("account"), param<Region>("region")],
  async (account, region) => {
    try {
      const portals = await externalApi.portalDiscovery.listPortals(account, region);
      return {region, portals};
    } catch {
      return {region, portals: null};
    }
  },
);
